"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _payChannel = require("@/api/payChannel");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PayChannelForm',
  props: {
    appId: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      payChannelOptions: [],
      form: {
        id: null,
        companyAppId: this.appId,
        payChannel: '',
        merchantNo: '',
        merchantKey: '',
        publicMerchantKey: '',
        payChannelPublicKey: '',
        certSerialNo: '',
        certPath: '',
        extraConfig: '{}'
      },
      extraList: [{
        key: '',
        value: ''
      }],
      rules: {
        payChannel: [{
          required: true,
          message: '请选择支付通道',
          trigger: 'change'
        }],
        merchantNo: [{
          required: true,
          message: '请输入商户号',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    editData: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          // 编辑
          this.payChannelInfo(val.id);
        } else {
          this.extraList = [];
          this.resetForm();
        }
        if (val !== null && val !== void 0 && val.extraConfig) {
          try {
            var obj = JSON.parse(val.extraConfig);
            this.extraList = Object.keys(obj).map(function (k) {
              return {
                key: k,
                value: obj[k]
              };
            });
          } catch (e) {
            this.extraList = [];
          }
        }
      }
    }
  },
  created: function created() {
    this.loadPayChannelOptions();
  },
  methods: {
    loadPayChannelOptions: function () {
      var _loadPayChannelOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _payChannel.getPayChannelOption)();
            case 1:
              res = _context.v;
              this.payChannelOptions = res || [];
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function loadPayChannelOptions() {
        return _loadPayChannelOptions.apply(this, arguments);
      }
      return loadPayChannelOptions;
    }(),
    payChannelInfo: function payChannelInfo(id) {
      var _this = this;
      (0, _payChannel.getPayChannelInfo)(id).then(function (res) {
        _this.form = res || {};
      });
    },
    resetForm: function resetForm() {
      this.form = {
        id: null,
        companyAppId: this.appId,
        payChannel: '',
        merchantNo: '',
        merchantKey: '',
        publicMerchantKey: '',
        payChannelPublicKey: '',
        certSerialNo: '',
        certPath: '',
        extraConfig: '{}'
      };
    },
    submit: function submit() {
      var _this2 = this;
      this.buildExtraConfig();
      this.$refs.payForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this2.loading = true;
                _context2.p = 2;
                if (!_this2.form.id) {
                  _context2.n = 4;
                  break;
                }
                _context2.n = 3;
                return (0, _payChannel.updatePayChannel)(_this2.form);
              case 3:
                _context2.n = 5;
                break;
              case 4:
                _context2.n = 5;
                return (0, _payChannel.addPayChannel)(_this2.form);
              case 5:
                _this2.$message.success('保存成功');
                _this2.$emit('success');
              case 6:
                _context2.p = 6;
                _this2.loading = false;
                return _context2.f(6);
              case 7:
                return _context2.a(2);
            }
          }, _callee2, null, [[2,, 6, 7]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    addExtra: function addExtra() {
      this.extraList.push({
        key: '',
        value: ''
      });
      var keys = this.extraList.map(function (i) {
        return i.key;
      }).filter(Boolean);
      if (new Set(keys).size !== keys.length) {
        this.$message.error('配置名不能重复');
      }
    },
    removeExtra: function removeExtra(index) {
      this.extraList.splice(index, 1);
    },
    /** 提交前格式化 */buildExtraConfig: function buildExtraConfig() {
      var obj = {};
      this.extraList.forEach(function (item) {
        if (item.key) {
          obj[item.key] = item.value;
        }
      });
      this.form.extraConfig = JSON.stringify(obj);
    }
  }
};